<template>
  <div>
    <div class="g-nav nav-pc">
    <div class="g-nav-site">
    </div>
    <div>
      <div class="g-nav-row">
        <div class="g-nav-content">
            <!-- <template class="HomeShow" >
                <img src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202307/b38df361d8cc4256a7a6250ce2aef683.png" alt="" style="width: 20px;height:20px;position: relative; top: 10px;    right: 30px;" @click="linkToRouterHome">
            </template> -->
          <!-- <div class="nav-item" v-for="(item, index) in routerArr" :key="'routerArr-' + index" :class="{active: index === activeIndex || (item.name === 'Product Category' && $route.path === '/homeEn')}" @click="linkToRouter(item,index);"> -->
          <div class="nav-item" v-for="(item, index) in routerArr" :key="'routerArr-' + index" :class="{active: index === activeIndex}" @click="linkToRouter(item,index);">
            
            <template v-if="item.name !== 'Product Category' && item.name !== 'Conference & Event' && item.name !== 'News' && item.name !== 'Brand Exhibitions'&& item.name !== 'HomeShow'">
              {{item.name}}
            </template>
            <template v-if="item.name === 'Conference & Event'">
              {{item.name}}
              <div class="act-list" style="width:200%;">
                <div class="act-list-tab" @click="linkM">CMEF New Product Marathon @ Shanghai</div>
                <div class="act-list-tab tab-visitor">
                  Reception
                  <i class="icon iconfont icon-xiala"></i>
                  <div class="visitor">
                    <p @click="linkYL">Cloud University</p>
                    <p @click="linkYM">Cloud Conference</p>
                    <p>Offline Forum</p>
                  </div>
                </div>
                <div class="act-list-tab" @click="linkYR">Cloud Promotion</div>
                <div class="act-list-tab" @click="$router.push('/act-listEn')">Event Album</div>
              </div>
            </template>
            <template v-if="item.name === 'Product Category'">
              {{item.name}}
              <div class="act-list pro-list" v-if="categoryList && categoryList.length">
                <!-- <div class="act-list pro-list" :style="($router.history.current.path === '/homeEn')?'display:block':''" v-if="categoryList && categoryList.length"> -->
                <div class="act-list-tab" v-for="(itm,idx) in categoryList" :key="idx" :class="itm.list && itm.list.length?'tab-visitor':''" v-if="idx < 8">
                  <p :title="itm.nameEn">{{itm.nameEn}}</p>
                  <i v-if="itm.list && itm.list.length" class="icon iconfont icon-xiala"></i>
                  <div class="visitor">
                    <div class="visitor-two" v-for="(im,ix) in itm.list" :key="ix" :title="im.nameEn" v-if="ix < 10">
                      <p :title="im.nameEn">{{im.nameEn}}</p>
                      <i v-if="im.list && im.list.length" class="icon iconfont icon-xiala"></i>
                      <div class="visitor-three" v-if="im.list && im.list.length">
                        <p @click="searchThree(m)" v-for="(m,x) in im.list" :key="x" :title="m.nameEn" v-if="x < 10">{{m.nameEn}}</p>
                      </div>
                    </div>
                    <div v-if="itm.list.length > 10" class="visitor-two" style="text-align:center;" @click="linkToMore()">More</div>
                  </div>
                </div>
                <div v-if="categoryList.length > 10" class="act-list-tab more" @click="linkToMore()">More</div>
              </div>
            </template>
            <template v-if="item.name === 'News'">
              {{item.name}}
              <div class="act-list">
                <div class="act-list-tab" style="text-align:center;padding-left:0;" @click="linkToNews(0)">Industry News</div>
                <div class="act-list-tab" style="text-align:center;padding-left:0;" @click="linkToNews(1)">Exhibitor News</div>
              </div>
            </template>
            <template v-if="item.name === 'Brand Exhibitions'">
              {{item.name}}
              <div class="act-list">
                <div class="act-list-tab" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;padding-right:20px;" @click="linkToPlan(pim)" v-for="(pim,pdx) in planList" :key="pdx">{{pim.shortNameEn}}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="nav-mobile" :class="navMobile ? 'bg' : ''">
    <div class="nav-mobile-f">
      <div class="nav-mobile-img">
        <img src="./img/logo.png" alt="" srcset="">
      </div>
      <div class="nav-mobile-icon" @click="navMobile = !navMobile">
        <i class="icon iconfont icon-ego-menu"></i>
      </div>
    </div>
    <div class="nav-mobile-list" v-show="navMobile">
      <div class="close" @click="navMobile = false">
        <i class="icon iconfont icon-guanbi2"></i>
      </div>
      <div class="nav-item" v-for="(item, index) in routerArr" :key="'routerArr-' + index" :class="{active: index === activeIndex}" @click="linkToRouter(item,index);">
            
            <template v-if="item.name !== 'Product Category' && item.name !== 'Conference & Event' && item.name !== 'News' && item.name !== 'Brand Exhibitions'&& item.name !== 'HomeShow'">
              {{item.name}}
            </template>
            <template v-if="item.name === 'Conference & Event'">
              {{item.name}}
              <div class="act-list" style="width:200%;">
                <div class="act-list-tab" @click="linkM">CMEF New Product Marathon @ Shanghai</div>
                <div class="act-list-tab tab-visitor">
                  Reception
                  <i class="icon iconfont icon-xiala"></i>
                  <div class="visitor">
                    <p @click="linkYL">Cloud University</p>
                    <p @click="linkYM">Cloud Conference</p>
                    <p>Offline Forum</p>
                  </div>
                </div>
                <div class="act-list-tab" @click="linkYR">Cloud Promotion</div>
                <div class="act-list-tab" @click="$router.push('/act-listEn')">Event Album</div>
              </div>
            </template>
            <template v-if="item.name === 'Product Category'">
              {{item.name}}
              <div class="act-list pro-list" v-if="categoryList && categoryList.length">
                <!-- <div class="act-list pro-list" :style="($router.history.current.path === '/homeEn')?'display:block':''" v-if="categoryList && categoryList.length"> -->
                <div class="act-list-tab" v-for="(itm,idx) in categoryList" :key="idx" :class="itm.list && itm.list.length?'tab-visitor':''" v-if="idx < 8">
                  <p :title="itm.nameEn">{{itm.nameEn}}</p>
                  <i v-if="itm.list && itm.list.length" class="icon iconfont icon-xiala"></i>
                  <div class="visitor">
                    <div class="visitor-two" v-for="(im,ix) in itm.list" :key="ix" :title="im.nameEn" v-if="ix < 10">
                      <p :title="im.nameEn">{{im.nameEn}}</p>
                      <i v-if="im.list && im.list.length" class="icon iconfont icon-xiala"></i>
                      <div class="visitor-three" v-if="im.list && im.list.length">
                        <p @click="searchThree(m)" v-for="(m,x) in im.list" :key="x" :title="m.nameEn" v-if="x < 10">{{m.nameEn}}</p>
                      </div>
                    </div>
                    <div v-if="itm.list.length > 10" class="visitor-two" style="text-align:center;" @click="linkToMore()">More</div>
                  </div>
                </div>
                <div v-if="categoryList.length > 10" class="act-list-tab more" @click="linkToMore()">More</div>
              </div>
            </template>
            <template v-if="item.name === 'News'">
              {{item.name}}
              <div class="act-list">
                <div class="act-list-tab" style="text-align:center;padding-left:0;" @click="linkToNews(0)">Industry News</div>
                <div class="act-list-tab" style="text-align:center;padding-left:0;" @click="linkToNews(1)">Exhibitor News</div>
              </div>
            </template>
            <template v-if="item.name === 'Brand Exhibitions'">
              {{item.name}}
              <div class="act-list">
                <div class="act-list-tab" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;padding-right:20px;" @click="linkToPlan(pim)" v-for="(pim,pdx) in planList" :key="pdx">{{pim.shortNameEn}}</div>
              </div>
            </template>
          </div>
    </div>
  </div>
  </div>
  
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "g-nav",
  data () {
    return {
      navMobile: false,
      activeIndex: 0,
      routerArr: [
        // { name: "HomeShow" },
        { name: "HOME" },

        // { name: "Product Category" },
        {
          name: "Product",
          router: "/ex-listEn",
          children: [
            { name: "展商详情", router: "/ex-detailsEn/" },
            { name: "产品详情", router: "/pro-detailsEn/" }
          ]
        },
        {
          name: "Exhibitor",
          router: "/ex-listEn2",
         
        },
        // {
        //   name: "新品马拉松",
        //   router: "/act-list",
        //   children: [{ name: "活动详情", router: "/activity-details/" }]
        // },
        {
          name: "Matchmaking",
          router: "/chanceEn",
          children: [{ name: "商机详情", router: "/chance-detailEn" }]
        },
        // { name: "Conference & Event" },

        // { name: "CMEF云课", router: "/home2" },
        // { name: "联系我们", router: "/contact" },
        { name: "New Products", router: "/act-xinpinhui" },
        { name: "Trending Products",router: "/act-zhenpinhui"  },

        //   { name: "Brand Exhibitions" },
        { name: "Live", router: "/homeEn" },
        
      ],
      site: "Home",
      categoryList: [],
      caDisplay: true,
      planList: []
    };
  },
  watch: {
    $route (to, from) {
      this.setIndex();
    }
  },
  computed: {
    ...mapGetters({
      exhibitionId: 'getExhibitionId',
    })
  },
  created () {
    let categoryList = JSON.parse(sessionStorage.getItem('categoryList'));
    if (categoryList && categoryList.length) {
      this.categoryList = categoryList;
    } else {
      this.getCategory();
    }
    this.setIndex();
    this.getPlan();
  },
  methods: {
    ...mapMutations({
      setCaId: "exhibitor/setCaId"
    }),
    ...mapActions({
      getProductCategory: "exhibitor/getProductCategory",
      getExhibitionPlan: "exhibitor/getExhibitionPlan",
    }),
      setIndex () {
        
      const path = this.$route.path;
      // const path = this.$router.history.current.path;
      this.routerArr.some((el, idx) => {
        // console.log(path,el,idx)
        if (el.router && path.search(el.router) !== -1) {
          this.activeIndex = idx;
          this.site = el.name;
        }

        if (el.children && el.children.length) {
          el.children.forEach(c => {
            if (path.indexOf(c.router) !== -1) {
              this.activeIndex = idx;
              this.site = c.name;
            }
          });
        }

        if (path === "/act-listEn" || path.indexOf("/activity-detailsEn") !== -1) {
          this.activeIndex = 4;
        }
        if (path === "/aboutEn") {
          this.activeIndex = idx;
        }
        if (path === "/newsEn" || path === "/news-detailsEn") {
          this.activeIndex = 5;
        }
        if (path === "/contactEn") {
          this.activeIndex = 6;
        }
      });
      if (path === "/home2En") {
        this.activeIndex = 1;
        this.$router.push("/homeEn");
        this.site = "Home";
      }
    },
    async getPlan () {
      let list = await this.getExhibitionPlan();
      if (list && list.length > 0) {
        this.planList = list;
      } else {
        this.planList = [];
      }
      this.planList.push({
        shortNameEn: "Contact us"
      });
    },
    linkToRouterHome () {
             window.location.href="https://www.cmef.com.cn/en";
    },
      linkToRouter (item, index) {
          if (item.name == "HOME") { 
              window.location.href = "https://www.cmef.com.cn/en";
             return
          }


      if (item.router) {
        this.activeIndex = index;
        this.$router.push(item.router);
        if (item.router === "/home2En") {
          this.activeIndex = 0;
          this.$router.push("/homeEn");
          this.site = "Home";
        }
      }
      this.navMobile = false
    },

    async getCategory () {
      let list = await this.getProductCategory(this.exhibitionId);
      if (list && list.length) {
        this.categoryList = list;
        sessionStorage.setItem('categoryList', JSON.stringify(this.categoryList));
      }
      // console.log("分类列表：",this.categoryList);
    },
    linkToMore () {
      // if (this.$route.fullPath === '/ex-list') {
      //   return;
      // }
      // this.caDisplay = false;
      // this.$router.push("/ex-list");

      // 修改：
      const url = location.origin + "/ex-listEn";
      window.open(url, "_blank");
    },
    searchThree (e) {
      // if (this.$route.fullPath === '/ex-list') {
      //   this.caDisplay = false;
      //   this.setCaId(e.id);
      //   setTimeout(() => {
      //     this.caDisplay = true;
      //   },100)
      //   return;
      // }
      // this.caDisplay = false;
      // this.setCaId(e.id);
      // this.$router.push("/ex-list");

      // 修改：
      const url = location.origin + "/ex-listEn?id=" + e.id + "&" + e.name;
      window.open(url, "_blank");
   
    },

    linkToPlan (e) {
       
      if (e.shortNameEn === "Contact us") {
        this.$router.push("/contactEn");
      } else {
        this.$router.push("/aboutEn?id=" + e.id + "&name=" + e.nameEn);
        
      }
    },
    linkToNews (e) {
      this.$router.push("/newsEn?type=" + e);
    },
    linkM () {
      window.open('https://marathon.cmef.com.cn/', '_blank');
    },
    linkYL () {
      window.open('https://live.cmef.com.cn/page/945270', '_blank');
    },
    linkYM () {
      window.open('https://live.cmef.com.cn/all/2152522', '_blank');
    },
    linkYR () {
      window.open('https://live.cmef.com.cn/all/2152523', '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>

@media (min-width: 799px) {
  .nav-pc{
    display: block;
  }
  .nav-mobile{
    display: none;
  }
}
@media (max-width: 799px) {
  .nav-pc{
    display: none;
  }
  // .active{
  //   color: #024c8b;
  // }
  .bg{
    // background-color: #CCCA;
  }
  .nav-mobile{
    display: block;
    width: 100%;
    // height: calc(96vw/7.6);
    line-height: calc(96vw/7.6);
    // width: 100%;
    // height: 100%;
    box-shadow: 0px 3px 5px 0px 
      rgba(0, 0, 0, 0.1);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;

    .nav-mobile-f{
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 calc(30vw/7.5);
      .nav-mobile-img{
        width: calc(140vw/7.5);
        display: flex;
        align-items: center;
        img{
          width: 100%;
        }
      }
      .nav-mobile-icon i{
        font-size: calc(40vw/7.5);
        color: #333;
      }
    }
    .nav-mobile-list{
      background-color: #fff;
      position: fixed;
      right: 0;
      top: 0;
      width: calc(500vw/7.5);
      height: 100%;
      box-shadow: -3px 0px 8px 0px 
		rgba(3, 0, 0, 0.1);
      .close{
        text-align: right;
        height: calc(90vw/7.5);
        line-height: calc(90vw/7.5);
        padding-right: calc(40vw/7.5);
        i{
          font-size: calc(48vw/7.5);
        }
      }
      .nav-item{
        height: calc(90vw/7.5);
        padding-left: calc(40vw/7.5);
        line-height: calc(90vw/7.5);
        border-top: 1px solid #f7f7f7;
        font-family: PingFang-SC-Medium;
        font-size: calc(30vw/7.5);
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }
    }
  }
}

.HomeShow{
    &:hover {
          background-color: #fff;
          color: #b1262d;
        }
}

.g-nav {
  width: 100%;
  height: 82px;
  background-color: #fff;
  color: #000;
  &-row {
    height: 42px;
    width: 1200px;
    margin: 0 auto;
  }
  &-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  .nav-item {
    font-size: 16px;
    width: 172px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    position: relative;
    .act-list {
      display: none;
      width: 100%;
      top: 42px;
      left: 0;
      position: absolute;
      z-index: 100;
      .more {
        padding-left: 0;
        text-align: center;
      }
      &-tab {
        background-color: rgba(2, 76, 139, 0.75);
        width: 100%;
        // height: 42px;
        text-align: left;
        padding-left: 20px;
        position: relative;
        border-bottom: 1px solid #0059a4;
        p {
          width: calc(100% - 42px);
          // overflow: hidden;
          // text-overflow:ellipsis;
          // white-space: nowrap;
          word-break: break-all;
          line-height: 1.5;
          padding: 10px 0;
        }
        i {
          position: absolute;
          top: 0;
          right: 20px;
          display: inline-block;
          transform: rotate(-90deg);
        }
        &:hover {
          opacity: 1;
          background-color: #fff;
          color: #b1262d;
        }
        .visitor {
          display: none;
          color: #fff;
          width: 100%;
          position: absolute;
          top: 0;
          right: -100%;
          height: auto;
          p {
            // height: 42px;
            background-color: rgba(2, 76, 139, 0.75);
            padding-left: 20px;
            // border-bottom: 1px solid #0059a4;
            &:hover {
              opacity: 1;
              background-color: #fff;
              color: #b1262d;
            }
          }
          .visitor-two {
            width: 100%;
            // height: 42px;
            background-color: rgba(2, 76, 139, 0.75);
            border-bottom: 1px solid #0059a4;
            position: relative;
            p {
              width: calc(100% - 42px);
              // height: 42px;
              padding-left: 20px;
              background-color: transparent;
            }
            &:hover {
              opacity: 1;
              background-color: #fff;
              color: #b1262d;
              .visitor-three {
                display: block;
              }
            }
          }
          .visitor-three {
            color: #fff;
            width: 100%;
            display: none;
            position: absolute;
            top: 0;
            right: -100%;
            height: auto;
            p {
              // height: 42px;
              background-color: rgba(2, 76, 139, 0.75);
              padding-left: 20px;
              border-bottom: 1px solid #0059a4;
              width: calc(100% + 20px);
              padding-right: 20px;
              &:hover {
                opacity: 1;
                background-color: #fff;
                color: #b1262d;
              }
            }
          }
        }
      }
      .tab-visitor {
        &:hover {
          .visitor {
            display: block;
          }
        }
      }
    }
    .pro-list {
      width: 150%;
      font-size: 14px;
    }
    &.active,
    &:hover {
      background-color: #024c8b;
      color: #fff;
    }
    &:hover {
      .act-list {
        display: block;
      }
    }
  }
  &-site {
    width: 1200px;
    height: 40px;
    margin: 0 auto;
    // display: flex;
    // justify-content: space-between;
    text-align: right;
    .site-l {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      i {
        font-size: 22px;
        color: #024c8b;
      }
    }
    .site-r {
      height: 100%;
      line-height: 40px;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>